import {combineReducers} from 'redux-immutable';

import menuReducer from '../menu/reducer';


export default combineReducers({
    menu: menuReducer,
    applicationsMenu: menuReducer,
});
